import { render, staticRenderFns } from "./candidateJobForm.vue?vue&type=template&id=5dd5711c&%23default=true&"
import script from "./candidateJobForm.vue?vue&type=script&lang=js&"
export * from "./candidateJobForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports